import instaciaAxios from './InterceptorAxios';

const servicioCruces = {

    buscarCrucesSinRegistro(){
        return instaciaAxios.post('sinregistro/cruce/buscarCrucesSinRegistro.json');
    },

    validarCruceSinRegistro(cruce){
        return instaciaAxios.post('sinregistro/cruce/validarCruceSinRegistro.json',cruce);
    },
    eliminarCruceSinRegistro(cruce){
        return instaciaAxios.post('sinregistro/cruce/eliminarCruceSinRegistro.json',cruce);
    },    
    generarFacturaSinRegistro(receptor){
        return instaciaAxios.post('sinregistro/cruce/generarFacturaSinRegistro.json',receptor);
    },

    buscarCrucesRegistro(){
        return instaciaAxios.post('cruce/buscarCrucesRegistro.json');
    },

    validarCruceRegistro(cruce){
        return instaciaAxios.post('cruce/validarCruceRegistro.json',cruce);
    },
    eliminarCruceRegistro(cruce){
        return instaciaAxios.post('cruce/eliminarCruceRegistro.json',cruce);
    },
    generarFacturaRegistro(receptor){
        return instaciaAxios.post('cruce/generarFacturaRegistro.json',receptor);
    },
    liberarNru(cruce){
        return instaciaAxios.post('/cruce/liberarNru.json',cruce);
    },
    vigenciaNru(cruce){
        return instaciaAxios.post('/cruce/vigenciaNru.json',cruce);
    }

}

export default servicioCruces;